import Deserialize from "./interface/Deserialize"
import {
  IAlacarteInfo,
  IAlacarteProps,
  IBundleInfo,
  IBundleProps,
  IQuotation,
} from "./interface/IQuotation"
import { BundleType } from "./BundleType"

export class BundleInfo implements Deserialize, IBundleInfo {
  id = ""
  sku_name = ""
  label = ""
  type = BundleType.ALIGNER
  description = {
    price: 0,
    standard_shipping: {} as IBundleProps,
    retainer: {} as IBundleProps,
    aligner: {} as IBundleProps,
    template: {} as IBundleProps,
    custom_packaging: {} as IBundleProps,
    aligner_case: {} as IBundleProps,
    "5_day_shipping": {} as IBundleProps,
    uassist: {
      included: 0,
      requested: 0,
      consumed: 0,
      leftAfterOrder: 0,
      type: []
    },
  }
  alacarte? = {
    name: "",
    sku_name: "",
    aligner: {} as IAlacarteProps,
    retainer: {} as IAlacarteProps,
    template: {} as IAlacarteProps,
    custom_packaging: {} as IAlacarteProps,
    price: null
  }
  name = ""
  total_price = 0
  bundlePrice = 0
  Deserialize(input: any): this {
    if (input.id) {
      this.id = input.id
      this.sku_name = input.sku_name
      this.description = { ...input.description }
      this.alacarte = input?.description?.alacarte
      this.name = input.label
      this.label = input.label
      this.type = input.type === BundleType.ALIGNER ? BundleType.ALIGNER : BundleType.RETAINER
      this.total_price = input?.case_total
      this.bundlePrice = input.price
    }
    return this
  }
}

export class Quotation implements IQuotation, Deserialize {
  bundlesAvailable = false
  isBundleCompleted = false
  isCurrentBundle = false
  isAlaCartePurched = false
  bundlesPurchasedForCase = false
  previousUassistCredit = 0
  currency = ""
  alacarte = {} as IAlacarteInfo
  bundles = [] as IBundleInfo[]
  previouslyOrderedPricing = null
  isAlignerCase = false
  remainingOrder = {
    aligner: { total_count: 0, remaining_count: 0 },
    retainer: { total_count: 0, remaining_count: 0 },
    template: { total_count: 0, remaining_count: 0 }
  }
  hasActiveBundle: any

  private deserializeAlacarte(data: any): any {
    const {
      type,
      label,
      sku_name,
      description
    } = data;

    return {
      type,
      label,
      sku_name,
      name:label,
      ...description
    };
  }

  Deserialize(res: any): this {
    if (res?.bundle_items?.length) {
      const input = res
      this.bundlesAvailable = input.bundles_available
      this.bundlesPurchasedForCase = input.bundles_purchased_for_case
      this.previousUassistCredit = input.previous_uassist_credit
      this.currency = input.currency
      if (input.bundle_items?.length) {
        const list = []
        const bundleList = input.bundle_items
        bundleList.forEach((item) => {
          if (item.type === BundleType.ALIGNER || item.type === BundleType.RETAINER) {
            list.push(new BundleInfo().Deserialize(item))
          }
          if (item.type === BundleType.ALACARTE) {
            this.isAlaCartePurched =
              input.previously_ordered_pricing &&
              input.previously_ordered_pricing.toLowerCase() === BundleType.ALACARTE
            this.alacarte = this.deserializeAlacarte(item)
          }
        })
        this.bundles = list
      }
      if (input.previously_ordered_pricing && input.bundle_items) {
        this.isCurrentBundle = true
      }
      this.previouslyOrderedPricing = input.previously_ordered_pricing || null
      this.hasActiveBundle = input.has_active_bundle
      this.isAlignerCase = input.is_aligner_case
      this.remainingOrder = input.tx_complete_order

      // if (!input.bundles_available && input.bundles_purchased_for_case) {
      //   this.isBundleCompleted = true
      //   if (!input.bundle_items) {
      //     const bundle = new BundleInfo()
      //     bundle.name = input.previously_ordered_pricing.charAt(0).toUpperCase() +
      //       input.previously_ordered_pricing.slice(1)
      //     bundle.sku_name = input.previously_ordered_pricing
      //     bundle.label = bundle.name
      //     bundle.type = bundle.name.toLowerCase().includes('aligner') ? BundleType.ALIGNER : BundleType.RETAINER
      //     this.bundles = [bundle]
      //     if (input.alacarte) {
      //       this.alacarte = { ...input.alacarte }
      //     }
      //   } else {
      //     const bundle = this.bundles[0]
      //     if (this.bundleType === "RETAINER") {
      //       this.isBundleCompleted =
      //         bundle &&
      //         bundle?.description &&
      //         bundle?.description?.retainer?.consumed ===
      //         bundle?.description?.retainer?.included
      //     }

      //     if (this.bundleType === "ALIGNER") {
      //       this.isBundleCompleted =
      //         bundle &&
      //         bundle?.description &&
      //         bundle?.description?.retainer?.consumed ===
      //         bundle?.description?.retainer?.included
      //     }
      //   }
      // }
    }
    return this
  }
}